import "moment/min/locales";

import Aiim from "../aiim/base/Aiim";
import AppMode from "./AppMode";
import Bluedot from "../aiim/ips/Bluedot";
import Configuration from "./Configuration";
import EsriLib from "./EsriLib";
import Session from "./Session";
import Speech from "../util/Speech";
import Toaster from "../util/Toaster";
import UIMode from "./UIMode";
import User from "./User";
import * as esriLoader from "esri-loader";

export default class Context {

  aiim;
  appMode;
  bluedot;
  config;
  configuration;
  i18n;
  isKiosk = false;
  lib = {
    esri: {},
    dojo: {},
    dojox: {},
    indoors: {}
  };
  portal;
  session;
  speech;
  supports3D = true;
  toaster;
  uiMode;
  user;
  versionInfo;
  views;

  spaceplanner = {
    activePlan: null,
    planid: null,
    planner: null,
  };

  static instance;

  static checkMixedContent(uri) {
    if (typeof window.location.href === "string" &&
        window.location.href.indexOf("https://") === 0) {
      if (typeof uri === "string" && uri.indexOf("http://") === 0) {
        uri = "https:" + uri.substring(5);
      }
    }
    return uri;
  }

  static getInstance() {
    if (!this.instance) {
      this.instance = new this();
      //window.AppContext = this.instance; // TODO temporary
    }
    return this.instance;
  }

  static logToTextarea(msg) {
    // <textarea id="tmptxt" style="position:absolute;top:0;left:0;z-index:9999;"></textarea>
    try {
      let textarea = document.getElementById("tmptxt");
      if (textarea) textarea.value = msg;
    } catch(ex) {}
  }

  getPortal() {
    return this.user && this.user.portal;
  }

  getPortalUrl() {
    return Context.checkMixedContent(this.config.portalUrl);
  }

  getSharingUrl() {
    return Context.checkMixedContent(this.config.portalUrl + "/sharing");
  }

  _init() {
    let localPortalUrl, jsapiUrl = window.jsapiUrl;
    if (typeof jsapiUrl === "string" && jsapiUrl.indexOf("../..") === 0) {
      // local Portal deployment
      let pathname = window.location.pathname;
      let idx = pathname.indexOf("/apps/");
      if (idx > 0) {
        localPortalUrl = pathname.substring(0,idx);
        jsapiUrl = window.jsapiUrl = localPortalUrl + "/jsapi/jsapi4/";
      }
      idx = window.location.href.indexOf("/apps/");
      if (idx > 0) {
        localPortalUrl = window.location.href.substring(0,idx);
      }
    }
    const esriLoaderOptions = {
      url: jsapiUrl,
      dojoConfig: window.dojoConfig
    };

    return esriLoader.loadModules([
      "dojo/text!./app/config/config.json",
      "dojo/text!./app/config/version.json",
      "dojo/i18n!app/nls/resources.js"
    ],esriLoaderOptions).then(([
      config,
      versionFile,
      i18n
    ]) => {

      this.i18n = i18n;
      this.config = JSON.parse(config);
      this.versionInfo = JSON.parse(versionFile);

      if (this.config.portalUrl === "../.." && localPortalUrl) {
        this.config.portalUrl = localPortalUrl;
      }
      this.config.portalUrl = Context.checkMixedContent(this.config.portalUrl);

      this.configuration = new Configuration();

      const esriLib = new EsriLib();
      this.lib = esriLib.lib;
      return esriLib.load(esriLoaderOptions);

    }).then(() => {

      this.appMode = new AppMode();
      this.appMode.init();
      this.speech = new Speech();
      this.uiMode = new UIMode();
      this.uiMode.init();
      this.isKiosk = this.uiMode.isKiosk;
      this.user = new User();
      this.session = new Session();
      this.toaster = new Toaster();
      this.aiim = new Aiim();
    });
  }

  _load() {
    return this.configuration._load().then(() => {
      this.bluedot = new Bluedot();
    });
  }

}
